import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import EmptyState from '@lib/components/EmptyState/EmptyState';
import Trans from '@lib/components/Trans/Trans';
import { IconName } from '@lib/components/Modal/enums';
import { TableTabs } from './enums';

type Props = {
  isEmptyState: boolean;
  isEmptyStateByFilter: boolean;
  isEmptyStateBySearch: boolean;
  onResetFilter: () => void;
  onResetSearch: () => void;
  tabParam?: TableTabs;
};

function getEmptyStateTextKeys(tabParam?: TableTabs) {
  switch (tabParam) {
    case TableTabs.All:
      return ['no-data-yet', 'no-data-text'];
    case TableTabs.Selected:
      return ['no-options-selected-yet', 'no-options-selected-text'];
    default:
      return ['no-data-yet', 'no-data-text'];
  }
}

function ModalTableEmptyState(props: Props) {
  const {
    isEmptyState,
    isEmptyStateByFilter,
    isEmptyStateBySearch,
    onResetFilter,
    onResetSearch,
    tabParam,
  } = props;
  const { t } = useTranslation();
  const [emptyStateTitleKey, emptyStateTextKey] =
    getEmptyStateTextKeys(tabParam);

  if (isEmptyStateBySearch) {
    return (
      <EmptyState
        title={t('no-results-found')}
        text={t('no-results-found-text')}
        icon={IconName.SearchOff}
        actions={[
          <Button
            key="back"
            buttonText={t('go-back')}
            buttonType={ButtonTypes.primaryFilled}
            leftIcon="arrow_back"
            onClick={onResetSearch}
          />,
        ]}
      />
    );
  }

  if (isEmptyStateByFilter) {
    return (
      <EmptyState
        title={t('no-results-found')}
        text={t('try-something-else')}
        icon={IconName.SearchOff}
        actions={[
          <Button
            key="back"
            buttonText={t('clear-filtering')}
            buttonType={ButtonTypes.primaryFilled}
            onClick={onResetFilter}
          />,
        ]}
      />
    );
  }

  if (isEmptyState) {
    return (
      <EmptyState
        title={t(emptyStateTitleKey)}
        text={<Trans i18nKey={emptyStateTextKey} />}
        icon={IconName.Cancel}
      />
    );
  }

  return null;
}

export default ModalTableEmptyState;
